import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { openContentPopup } from "../../store/actions";

const MenuItem = (props) => {
  const isActive = () => [props.name, ...(props.subNames || [])].includes(props.activeContentPopup);

  const [active, setActive] = useState(isActive());

  useEffect(() => {
    setActive(isActive());
    return () => setActive(false);
  }, [props.activeContentPopup]);

  return (
    <li>
      <a
        className={`link icon icon-${props.icon} ${active ? "active" : ""} ${props.disabled ? "disabled" : ""}`}
        onClick={() => !props.disabled && props.openContentPopup({
          name: props.name,
          title: props.title,
          icon: props.icon,
          h1classes: props.h1classes
        })}
      >
        {props.label || props.name}
      </a>
    </li>
  )
};

const mapStateToProps = state => ({
  activeContentPopup: state.ui.showContentPopup && state.ui.showContentPopup.name
})

const mapDispatchToProps = dispatch => ({
  openContentPopup: contentPopupOptions => dispatch(openContentPopup(contentPopupOptions))
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuItem);
